// Full screen backdrop with a spinner, shown while a view waits for its data.
// Shown only after a short delay so quick loads don't flash it. It also
// blocks taps while it's visible.

const SHOW_DELAY = 150;
const VISIBLE = 'loading-overlay--visible';

let overlay;
// Waits currently showing the overlay; it hides when the last one is done
let shownBy = 0;

function getOverlay () {
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.className = 'loading-overlay';
    overlay.setAttribute('role', 'status');
    overlay.setAttribute('aria-label', 'Loading');
    overlay.innerHTML = '<span class="loading-overlay__spinner"></span>';
    document.body.appendChild(overlay);
  }
  return overlay;
}

/**
 * Shows the overlay after the delay, until the returned hide is called.
 * Calling hide more than once is harmless.
 *
 * @param {number} [delay]
 * @returns {() => void} hide
 */
export function showLoading (delay = SHOW_DELAY) {
  let shown = false;
  let done = false;

  const timer = setTimeout(() => {
    shown = true;
    if (++shownBy == 1) getOverlay().classList.add(VISIBLE);
  }, delay);

  return function hide () {
    if (done) return;
    done = true;
    clearTimeout(timer);
    if (shown && --shownBy == 0) overlay.classList.remove(VISIBLE);
  };
}
